import { BprocFormData } from "../../../../cuba/entities/bproc/bproc_FormData";

export const applyExcludeOutcomes = (
  formData: BprocFormData,
  excludeOutcomes: string[] | null,
): BprocFormData => {
  if (!excludeOutcomes) return formData;
  return {
    ...formData,
    outcomes: formData.outcomes?.filter(
      (outcome) => !excludeOutcomes.includes(outcome?.id),
    ),
  };
};
